import { RefreshCw } from "lucide-react";

export function LiveEmptyScreenshot({ isRunning }: { isRunning: boolean }) {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="max-w-sm space-y-3 px-8 text-center">
        {isRunning ? (
          <>
            <RefreshCw
              className="mx-auto h-4 w-4 animate-spin text-primary"
              aria-hidden="true"
            />
            <p className="text-sm text-muted-foreground">
              The persona is getting oriented.
            </p>
          </>
        ) : (
          <p className="text-sm text-muted-foreground">
            No screenshot for this step.
          </p>
        )}
      </div>
    </div>
  );
}
